import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconVideoRewind15 = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M13.5 22c5.385 0 9.75-4.365 9.75-9.75S18.885 2.5 13.5 2.5s-9.75 4.365-9.75 9.75V13",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M.75 9.997l3 3 3-3",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M4.95 21h1.007v-5.637H4.953L3.48 16.398v.95l1.403-.992h.066V21zm4.655.14c1.23 0 2.055-.808 2.055-1.988 0-1.133-.781-1.855-1.746-1.855-.574 0-.988.195-1.238.543h-.067l.157-1.649h2.593v-.828H7.98l-.308 3.278h.914c.191-.371.562-.594 1.043-.594.621 0 1.059.45 1.059 1.121 0 .691-.438 1.152-1.086 1.152-.575 0-1.008-.347-1.07-.875H7.59c.043.989.851 1.696 2.015 1.696z",
      fill: color
    })]
  }));
});
IconVideoRewind15.displayName = "IconVideoRewind15";

export { IconVideoRewind15 };
